<template>
    <v-container fluid class="incidente-root">
        <div>
            <h2 v-if="!soloLectura">Registro de Funcionarios</h2>
            <!-- Filtros -->
            <v-card class="pa-3 mb-3 filtros-card" outlined>
                <!-- Filtros principales -->
                <v-row dense align="center">
                    <v-col cols="12" md="4">
                        <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar por nombres, apellidos, correo o documento" outlined dense clearable />
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-select v-model="filtros.oid_estado" :items="Lestado" item-text="n_estado" item-value="oid" label="Estado" outlined dense multiple clearable />
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-autocomplete v-model="filtros.oid_grado" :items="Lgrado" item-text="nombre" item-value="oid" label="Grado" outlined dense multiple clearable />
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-autocomplete v-model="filtros.oid_unidad" :items="Lunidad" item-text="nombre" item-value="oid" label="Unidad" outlined dense multiple clearable />
                    </v-col>
                    <v-col cols="12" md="2" class="text-right">
                        <v-btn text color="#5e672c" @click="verFiltros = !verFiltros">
                            <v-icon left small>mdi-filter-variant</v-icon>
                            Más filtros
                        </v-btn>
                    </v-col>
                </v-row>
                <!-- Filtros avanzados -->
                <v-expand-transition>
                    <div v-if="verFiltros" class="mt-3">
                        <v-divider class="mb-3"></v-divider>
                        <v-row dense>
                            <!-- <v-col cols="12" md="3">
                                <v-select v-model="filtros.oid_tipo_documento" :items="Catalogo.TipoDocumento" item-text="nombre" item-value="oid" label="Tipo documento" outlined dense multiple clearable />
                            </v-col> -->
                            <v-col cols="12" md="2">
                                <v-select v-model="filtros.oid_genero" :items="Catalogo.Genero" item-text="nombre" item-value="oid" label="Género" outlined dense multiple clearable />
                            </v-col>
                            <v-col cols="12" md="2">
                                <v-select v-model="filtros.oid_estado_civil" :items="Catalogo.EstadoCivil" item-text="nombre" item-value="oid" label="Estado civil" outlined dense multiple clearable />
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-autocomplete v-model="filtros.oid_cargo" :items="Lcargo" item-text="nombre" item-value="oid" label="Cargo" outlined dense multiple clearable />
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-autocomplete v-model="filtros.oid_destino" :items="Ldestino" item-text="nombre" item-value="oid" label="Destino" outlined dense multiple clearable />
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-autocomplete v-model="filtros.oid_categoria" :items="Lcas" item-text="nombre" item-value="oid" label="Categoria CAS" outlined dense multiple clearable />
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-autocomplete v-model="filtros.oid_frontera" :items="Lfrontera" item-text="nombre" item-value="oid" label="Frontera" outlined dense multiple clearable />
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-autocomplete v-model="filtros.oid_funciones" :items="Lfunciones" item-text="nombre" item-value="oid" label="Función Policial" outlined dense multiple clearable />
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-autocomplete v-model="filtros.grado_policial" :items="Lgpolicial" item-text="nombre" item-value="oid" label="Grado Policial" outlined dense multiple clearable />
                            </v-col>
                        </v-row>
                    </div>
                </v-expand-transition>
            </v-card>
                        
            <div class="d-flex justify-space-between align-center mt-2 mb-4" style="width: 100%;">
                <!-- IZQUIERDA -->
                <v-btn v-if="!soloLectura" class="perfil-btn-primary" dark @click="nueva"> Registrar </v-btn>
                <!-- DERECHA -->
                <div class="d-flex align-center">
                    <v-btn small class="perfil-btn mr-2" style="background-color: #e4b510; text-transform: none;" dark @click="limpiarFiltros">
                        <v-icon left small>mdi-filter-remove</v-icon> Limpiar filtros
                    </v-btn>
                    <v-btn small class="perfil-btn mr-2" style="background-color: #e4b510; text-transform: none;" dark @click="exportarExcel">
                        <v-icon left small>mdi-microsoft-excel</v-icon> Exportar XLSX
                    </v-btn>
                    <v-btn small class="perfil-btn mr-2" style="background-color: #5e672c; text-transform: none;" dark @click="descargarPlantillaFuncionarios">
                        <v-icon left small>mdi-microsoft-excel</v-icon> Exportar Plantilla
                    </v-btn>
                    <v-btn small class="perfil-btn" style="background-color: #e4b510; text-transform: none;" dark @click="dialogImportar = true">
                        <v-icon left small>mdi-microsoft-excel</v-icon> Importar Plantilla
                    </v-btn>
                </div>
            </div>

            <!-- Diálogo para crear un nueva -->
            <v-dialog v-model="dialog" max-width="85%" scrollable persistent>
                <v-card class="perfil-dialog-card">
                    <v-card-title class="perfil-dialog-title">
                        <span>{{ formTitle }}</span>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="dialog = false" :disabled="dialog_guardando">
                            <v-icon color="#384018">mdi-close</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-card-text ref="dialogBody" class="perfil-dialog-body">
                        <v-form ref="form" v-model="formValid" lazy-validation>
                            <v-container fluid>
                                <v-row>
                                    <!-- INFORMACIÓN PERSONAL -->
                                    <v-col cols="12">
                                        <div class="form-section-title">Información Personal</div>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <!-- <v-text-field v-model="dato.correo" :rules="[r.email]" label="Correo" required outlined dense class="perfil-field" clearable/> -->
                                        <v-text-field v-model="dato.correo" :rules="[r.email, validarCorreoNoExiste]" label="Correo" required outlined dense class="perfil-field" clearable
                                            :loading="validandoCorreo" :error="existeCorreo" :error-messages="existeCorreo ? ['El correo ya existe'] : []" @input="validarCampoDuplicadoDebounce('correo')">
                                            <template v-slot:label>
                                                Correo <span class="required-star" color="red">*</span>
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <v-text-field v-model="dato.nombres" :rules="[r.req]" label="Nombres" required outlined dense class="perfil-field" clearable>
                                            <template v-slot:label>
                                                Nombres <span class="required-star" color="red">*</span>
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <v-text-field v-model="dato.primero_apellido" :rules="[r.req]" label="Primer apellido" required outlined dense class="perfil-field" clearable>
                                            <template v-slot:label>
                                                Primer apellido <span class="required-star" color="red">*</span>
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <v-text-field v-model="dato.segundo_apellido" label="Segundo apellido" outlined dense class="perfil-field" clearable/>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <v-text-field v-model="dato.tercer_apellido" label="Tercer apellido" outlined dense class="perfil-field" clearable/>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <v-select v-model="dato.oid_tipo_documento" :rules="[r.combo]" :items="Catalogo.TipoDocumento" item-text="nombre" item-value="oid"
                                            label="Tipo de documento" outlined dense class="perfil-field" clearable>
                                            <template v-slot:label>
                                                Tipo de documento <span class="required-star" color="red">*</span>
                                            </template>
                                        </v-select>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <!-- <v-text-field v-model="dato.documento" :rules="[r.req]" label="Nro de identificación" required outlined dense class="perfil-field" type="number" 
                                        min="0" step="1" @keydown="['-', '+', 'e', '.'].includes($event.key) && $event.preventDefault()"/> -->
                                        <v-text-field v-model="dato.documento" :rules="[r.req, validarDocumentoNoExiste]" label="Nro de identificación" required outlined dense class="perfil-field" type="number"
                                            min="0" step="1" :loading="validandoDocumento" :error="existeDocumento" :error-messages="existeDocumento ? ['El documento ya existe'] : []"
                                            @input="validarCampoDuplicadoDebounce('documento')" @keydown="['-', '+', 'e', '.'].includes($event.key) && $event.preventDefault()">
                                            <template v-slot:label>
                                                Nro de identificación <span class="required-star" color="red">*</span>
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                    
                                    <v-col cols="12" md="2">
                                        <v-select v-model="dato.oid_genero" :rules="[r.combo]" :items="Catalogo.Genero" item-text="nombre" item-value="oid"  label="Género"
                                            outlined dense class="perfil-field" clearable>
                                            <template v-slot:label>
                                                Género <span class="required-star" color="red">*</span>
                                            </template>
                                        </v-select>
                                    </v-col>
                                    <v-col cols="12" md="2">
                                        <v-select v-model="dato.oid_estado_civil" :rules="[r.combo]" :items="Catalogo.EstadoCivil" item-text="nombre" item-value="oid"
                                            label="Estado civil" outlined dense class="perfil-field" clearable>
                                            <template v-slot:label>
                                                Estado civil <span class="required-star" color="red">*</span>
                                            </template>
                                        </v-select>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <v-text-field v-model="dato.telefono" :rules="[r.phone]" label="Número celular" required outlined dense class="perfil-field" clearable>
                                            <template v-slot:label>
                                                Número celular <span class="required-star" color="red">*</span>
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <v-select v-model="dato.oid_nacionalidad_origen" :rules="[r.combo]" :items="Catalogo.Nacionalidad" item-text="nombre" item-value="oid"
                                            label="Nacionalidad origen" outlined dense class="perfil-field" clearable>
                                            <template v-slot:label>
                                                Nacionalidad origen <span class="required-star" color="red">*</span>
                                            </template>
                                        </v-select>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <v-select v-model="dato.oid_nacionalidad_actual" :rules="[r.combo]" :items="Catalogo.Nacionalidad" item-text="nombre" item-value="oid"
                                            label="Nacionalidad actual" outlined dense class="perfil-field" >
                                            <template v-slot:label>
                                                Nacionalidad actual <span class="required-star" color="red">*</span>
                                            </template>
                                        </v-select>
                                    </v-col>
                                    <!-- LABORAL -->
                                    <v-col cols="12" class="mt-2">
                                        <div class="form-section-title">Laboral</div>
                                    </v-col>
                                    <v-col cols="12" md="2">
                                        <!-- <v-text-field v-model="dato.cl1" label="Nro Escalafon" required outlined dense class="perfil-field" clearable/> -->
                                        <v-text-field v-model="dato.cl1" :rules="[r.req, validarEscalafonNoExiste]" label="Nro Escalafon" required outlined dense class="perfil-field"
                                            clearable :loading="validandoEscalafon" :error="existeEscalafon"
                                            :error-messages="existeEscalafon ? ['El Nro. Escalafón ya existe'] : []" @input="validarCampoDuplicadoDebounce('cl1')">
                                            <template v-slot:label>
                                                Nro Escalafon <span class="required-star" color="red">*</span>
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="2">
                                        <v-select v-model="dato.oid_estado" :rules="[r.combo]" :items="Lestado" item-text="n_estado" item-value="oid"
                                            label="Estado" outlined dense class="perfil-field" clearable>
                                            <template v-slot:label>
                                                Estado <span class="required-star" color="red">*</span>
                                            </template>
                                        </v-select>
                                    </v-col>
                                    <v-col cols="12" md="2">
                                        <v-text-field v-model="dato.fecha_ingreso" label="Fecha de ingreso" type="date" :rules="[r.date]" outlined dense class="perfil-field" clearable>
                                            <template v-slot:label>
                                                Fecha de ingreso <span class="required-star" color="red">*</span>
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="2">
                                        <v-text-field v-model="dato.fecha_retiro" label="Fecha de baja" type="date" outlined dense class="perfil-field" clearable/>
                                    </v-col>
                                    <v-col cols="12" md="2">
                                        <v-text-field v-model="dato.fecha_reintegro" label="Fecha de reincorporación" type="date" outlined dense class="perfil-field" clearable/>
                                    </v-col>
                                    <v-col cols="12" md="2">
                                        <v-text-field v-model="dato.fecha_reasignacion" label="Fecha de reasignacion" type="date" outlined dense class="perfil-field" clearable/>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <v-autocomplete v-model="dato.oid_grado" :rules="[r.combo]" :items="Lgrado" item-text="nombre" item-value="oid"
                                            label="Grado Policial" outlined dense class="perfil-field" clearable>
                                            <template v-slot:label>
                                                Grado Policial <span class="required-star" color="red">*</span>
                                            </template>
                                        </v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <v-autocomplete v-model="dato.grado_policial" :rules="[r.combo]" :items="Lgpolicial" item-text="nombre" item-value="oid"
                                            label="Nivel" outlined dense class="perfil-field" clearable>
                                            <template v-slot:label>
                                                Nivel <span class="required-star" color="red">*</span>
                                            </template>
                                        </v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <v-autocomplete v-model="dato.oid_cargo" :rules="[r.combo]" :items="Lcargo" item-text="nombre" item-value="oid"
                                            label="Cargo" outlined dense class="perfil-field" clearable>
                                            <template v-slot:label>
                                                Cargo <span class="required-star" color="red">*</span>
                                            </template>
                                        </v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <v-autocomplete v-model="dato.oid_funciones" :rules="[r.combo]" :items="Lfunciones" item-text="nombre" item-value="oid"
                                            label="Función Policial" outlined dense class="perfil-field" clearable>
                                            <template v-slot:label>
                                                Función Policial <span class="required-star" color="red">*</span>
                                            </template>
                                        </v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <v-autocomplete v-model="dato.oid_unidad" :rules="[r.combo]" :items="Lunidad" item-text="nombre" item-value="oid"
                                            label="Unidad" outlined dense class="perfil-field" clearable>
                                            <template v-slot:label>
                                                Unidad <span class="required-star" color="red">*</span>
                                            </template>
                                        </v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <v-autocomplete v-model="dato.oid_destino" :rules="[r.combo]" :items="Ldestino" item-text="nombre" item-value="oid"
                                            label="Destino" outlined dense class="perfil-field" clearable>
                                            <template v-slot:label>
                                                Destino <span class="required-star" color="red">*</span>
                                            </template>
                                        </v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <v-autocomplete v-model="dato.oid_frontera" :items="Lfrontera" item-text="nombre" item-value="oid"
                                            label="Frontera" outlined dense class="perfil-field" clearable/>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <v-autocomplete v-model="dato.oid_categoria" :items="Lcas" item-text="nombre" item-value="oid"
                                            label="Categoria CAS" outlined dense class="perfil-field" clearable/>
                                    </v-col>
                                    <!-- <v-col cols="12" md="2">
                                        <v-text-field v-model="dato.cl2" label="Documento" type="number" required outlined dense class="perfil-field" clearable/>
                                    </v-col> -->
                                    <!-- OTROS -->
                                    <v-col cols="12" class="mt-2">
                                        <div class="form-section-title">Otros</div>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <v-text-field v-model="dato.cod_salud" label="Codigo de salud" outlined dense class="perfil-field" clearable/>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <v-text-field v-model="dato.registro_cua" label="Registro CUA" :rules="[r.req]" required outlined dense class="perfil-field" type="number" 
                                        min="0" step="1" @keydown="['-', '+', 'e', '.'].includes($event.key) && $event.preventDefault()">
                                            <template v-slot:label>
                                                Registro CUA <span class="required-star" color="red">*</span>
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <v-text-field v-model="dato.nro_cuenta" label="Nro. de cuenta" outlined dense class="perfil-field" clearable/>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <v-text-field v-model="dato.expedido" label="Expedido" outlined dense class="perfil-field" clearable/>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <v-text-field v-model="dato.grado_incapacidad" label="Grado de incapacidad" outlined dense class="perfil-field" clearable/>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <v-text-field v-model="dato.bono_egresado" label="Bono egresado" outlined dense class="perfil-field" clearable/>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <v-text-field v-model="dato.cod_cargo" label="Codigo de cargo" outlined dense class="perfil-field" clearable/>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <v-select v-model="dato.oid_tipo_sangre" :items="Catalogo.TipoSangre" item-text="nombre" item-value="oid"
                                            label="Tipo de sangre" outlined dense class="perfil-field" clearable/>
                                    </v-col>
                                    <!-- LUGAR DE NACIMIENTO -->
                                    <v-col cols="12" class="mt-2">
                                        <div class="form-section-title">Lugar de Nacimiento</div>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <v-text-field v-model="dato.fecha_nacimiento" :min="minDate" :max="maxDate" :rules="[r.date]" label="Fecha de nacimiento"
                                            type="date" required outlined dense class="perfil-field" clearable>
                                            <template v-slot:label>
                                                Fecha de nacimiento<span class="required-star" color="red">*</span>
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <v-select v-model="dato.oid_pais_nacimiento" :items="LPais" item-text="nombre" item-value="oid" :rules="[r.combo]" label="País de nacimiento"
                                            required outlined dense class="perfil-field" clearable>
                                            <template v-slot:label>
                                                País de nacimiento <span class="required-star" color="red">*</span>
                                            </template>
                                        </v-select>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <v-select v-model="dato.oid_depto_nacimiento" :rules="[r.combo]" :items="deptoFiltradoN" item-text="nombre" item-value="oid"
                                            label="Departamento" required outlined dense class="perfil-field" clearable>
                                            <template v-slot:label>
                                                Departamento <span class="required-star" color="red">*</span>
                                            </template>
                                        </v-select>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <v-select v-model="dato.oid_ciudad_nacimiento" :rules="[r.combo]" :items="ciudadFiltradoN" item-text="nombre" item-value="oid"
                                            label="Ciudad, Localidad y Población" required outlined dense class="perfil-field" clearable>
                                            <template v-slot:label>
                                                Ciudad, Localidad y Población <span class="required-star" color="red">*</span>
                                            </template>
                                        </v-select>
                                    </v-col>
                                    <!-- UBICACIÓN ACTUAL -->
                                    <v-col cols="12" class="mt-2">
                                        <div class="form-section-title">Domicilio Actual</div>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <v-text-field v-model="dato.direccion" :rules="[r.req]" label="Dirección" required outlined dense class="perfil-field" clearable>
                                            <template v-slot:label>
                                                Ciudad, Localidad y Población <span class="required-star" color="red">*</span>
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="2">
                                        <v-text-field v-model="dato.calle" label="Calle" outlined dense class="perfil-field" clearable/>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <v-text-field v-model="dato.zona" label="Zona" outlined dense class="perfil-field" clearable/>
                                    </v-col>
                                    <v-col cols="12" md="2">
                                        <v-text-field v-model="dato.nro_domicilio" label="Nro. domicilio" outlined dense class="perfil-field" clearable/>
                                    </v-col>
                                    <v-col cols="12" md="2">
                                        <v-select v-model="dato.oid_pais" :rules="[r.combo]" :items="LPais" item-text="nombre" item-value="oid"
                                            label="País" required outlined dense class="perfil-field" clearable >
                                            <template v-slot:label>
                                                País <span class="required-star" color="red">*</span>
                                            </template>
                                        </v-select>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <v-select v-model="dato.oid_depto" :rules="[r.combo]" :items="deptoFiltrado" item-text="nombre" item-value="oid"
                                            label="Departamento" required outlined dense class="perfil-field" clearable>
                                            <template v-slot:label>
                                                Departamento <span class="required-star" color="red">*</span>
                                            </template>
                                        </v-select>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <v-select v-model="dato.oid_ciudad" :rules="[r.combo]" :items="ciudadFiltrado" item-text="nombre" item-value="oid"
                                            label="Ciudad" required outlined dense class="perfil-field" clearable>
                                            <template v-slot:label>
                                                Ciudad <span class="required-star" color="red">*</span>
                                            </template>
                                        </v-select>
                                    </v-col>
                                    <v-col cols="12">
                                        <div id="mapa" style="height: 300px; border-radius: 12px;" />
                                    </v-col>
                                    <v-col cols="12">
                                        <div class="dialog-help-text text-caption font-weight-medium">
                                            <span v-if="dato.lat && dato.lng">
                                                Lat: {{ Number(dato.lat).toFixed(6) }} | Lng: {{ Number(dato.lng).toFixed(6) }}
                                            </span>
                                            <span v-else>
                                                Selecciona una ciudad o haz clic en el mapa para capturar la ubicación.
                                            </span>
                                        </div>
                                    </v-col>
                                    <!-- CONTACTO DE EMERGENCIA -->
                                    <v-col cols="12" class="mt-2">
                                        <div class="form-section-title">Contacto de Emergencia</div>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <v-select v-model="dato.oid_parentesco_contacto" :items="Catalogo.Parentesco" item-text="nombre" item-value="oid"
                                            label="Parentesco" outlined dense class="perfil-field" clearable/>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <v-text-field v-model="dato.n_contacto" label="Nombre de contacto" outlined dense class="perfil-field" clearable/>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <v-text-field v-model="dato.nro_contacto" label="Nro. de contacto" outlined dense class="perfil-field" clearable/>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions class="perfil-dialog-actions">
                        <v-spacer></v-spacer>
                        <v-btn class="perfil-btn-outline" outlined @click="dialog = false" :disabled="dialog_guardando"> Cancelar </v-btn>
                        <v-btn :loading="dialog_guardando" :disabled="!formValid || dialog_guardando" class="perfil-btn-primary" @click="guardar"> {{ isNew ? 'Guardar' : 'Actualizar' }} </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-data-table :headers="headers" :items="datos" :server-items-length="totalItems" :options.sync="tableOptions" :loading="loadingTable" item-key="oid" 
            :footer-props="{ 'items-per-page-options': [30, 50, 100, 200, 500] }">
                <template v-slot:item.activo="{ item }">
                    {{ item.activo ? 'SI' : 'NO' }}
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-icon small class="mr-2" v-on="on" @click="mostrarPersona(item.oid)">mdi-eye</v-icon>
                        </template>
                        <span>Detalle</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-icon small class="mr-2" v-on="on" @click="editar(item)">mdi-pencil</v-icon>
                        </template>
                        <span>Editar</span>
                    </v-tooltip>
                    <!-- <v-tooltip bottom v-if="item.oid_rol != 2">
                        <template v-slot:activator="{ on }">
                            <v-icon small class="mr-2" color="red" v-on="on" @click="confirmarEliminar(item.oid)">mdi-delete</v-icon>
                        </template>
                        <span>Eliminar</span>
                    </v-tooltip> -->
                </template>
            </v-data-table>
        
            <!-- Formulario de creación/edición -->      
            <v-form ref="form" @submit.prevent="guardar">
            </v-form>

            <!-- Diálogo para ver detalle-->
            <v-dialog :key="dialogKeyD" v-model="dialogdetail" max-width="95%" content-class="perfil-detalle-dialog">
                <v-card class="perfil-detalle-card">
                    <v-card-title class="headline d-flex justify-space-between">
                        <span>Detalle</span>
                        <v-btn icon @click="dialogdetail = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-card-text class="perfil-dialog-body">
                        <div class="perfil-detalle-body">
                            <!-- <Perfil :key="dato.oid" :persona-id="dato.oid" :solo-lectura="true" /> -->
                            <Detalle_funcionario :key="dialogKeyD" :persona-id="dato.oid" :solo-lectura="true" />
                        </div>
                        </v-card-text>
                    <v-card-actions>
                        <v-btn class="perfil-btn-outline" outlined @click="dialogdetail = false;">Cerrar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <!-- Diálogo de confirmación para eliminar -->
            <v-dialog v-model="showConfirmDialog" max-width="500px">
                <v-card>
                <v-card-title class="headline">Confirmar eliminación</v-card-title>
                <v-card-text>
                    ¿Estás seguro de que deseas eliminar este registro?
                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary" text @click="eliminar(confirmItemId)">Sí</v-btn>
                    <v-btn color="secondary" text @click="cancelarEliminar">No</v-btn>
                </v-card-actions>
                </v-card>
            </v-dialog>

            <!-- Dialogo para Mensaje cargando-->
            <v-dialog v-model="dialog_guardando" max-width="550px"> 
                <v-card>
                    <v-card-title class="headline">Guardando .....</v-card-title>
                </v-card>
            </v-dialog>
            
            <v-snackbar v-model="snackbar" :color="snackbarColor" timeout="5000" top>
                {{ snackbarMensaje }}
                <template v-slot:action="{ attrs }">
                    <v-btn text v-bind="attrs" @click="snackbar = false">Cerrar</v-btn>
                </template>
            </v-snackbar>

            <ImportarFuncionarios v-model="dialogImportar" @importado="listar" @error="mostrarError" @success="mostrarSuccess" />

        </div>
    </v-container>
</template>
  
<script>
import axios from 'axios';
import { setRols, getRolN, getAreaN, setAreas, setEstados } from '@/utils/validators';
import {
  loadAll, getOptionsByCodigo,
  setDatos, getPaises, getDeptos, getCiudades,
  getPaisN, getDeptoN, getCiudadN,
  getnombresById
} from '@/utils/catalogo';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';
import Perfil from './Perfil.vue';
import { utils, writeFileXLSX  } from 'xlsx';
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import Detalle_funcionario from './Detalle_funcionario.vue';
import ImportarFuncionarios from './ImportarFuncionarios.vue';

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
    iconRetinaUrl: markerIcon2x,
    iconUrl: markerIcon,
    shadowUrl: markerShadow,
});
  
export default {
    components: {
        Perfil,
        Detalle_funcionario,
        ImportarFuncionarios
    },
    props: {
        soloLectura: { type: Boolean, default: false },
    },
    data() {
        return {
            datos: [], Larea: [], roles: [], Lestado: [],
            LPais: [], LDepto: [], LCiudad: [], Lgrado: [], Lcargo: [], Lunidad: [], Ldestino: [], Lcas: [], Lfunciones: [], Lgpolicial: [], Lfrontera: [],
            dato: {
                oid: 0,
                password_hash: 'aa',
                nombres: '',
                primero_apellido: '',
                segundo_apellido: '',
                tercer_apellido: '',
                oid_tipo_documento: null,
                documento: '',
                fecha_nacimiento: null,
                oid_pais_nacimiento: null,
                oid_depto_nacimiento: null,
                oid_ciudad_nacimiento: null,
                oid_nacionalidad_origen: null,
                oid_nacionalidad_actual: null,
                oid_estado_civil: null,
                direccion: '',
                calle: '',
                zona: '',
                nro_domicilio: '',
                oid_pais: null,
                oid_depto: null,
                oid_ciudad: null,
                n_contacto: '',
                nro_contacto: '',
                oid_parentesco_contacto: null,
                telefono: '',
                oid_user: null,
                verificado: null,
                activo: null,
                lat: null,
                lng: null,
                oid_estado: null,
                cl1: '',
                cl2: '',
                fecha_ingreso: null,
                fecha_retiro: null,
                fecha_reintegro: null,
                fecha_reasignacion: null,
                oid_grado: null,
                oid_cargo: null,
                oid_unidad: null,
                oid_destino: null,
                cod_salud: '',
                registro_cua: '',
                nro_cuenta: '',
                expedido: '',
                grado_incapacidad: '',
                oid_categoria: null,
                bono_egresado: '',
                cod_cargo: '',
                oid_tipo_sangre: null,
                oid_frontera: null,
                oid_funciones: null,
                grado_policial: null,
            },
            isNew: true,
            Ops: [
                { oid: 1, nombre: 'Si' },
                { oid: 0, nombre: 'No' },
            ],
            dialog: false, // Controla la visibilidad del diálogo
            formTitle: '', // Título del diálogo
            dialogdetail: false,
            showConfirmDialog: false,
            confirmItemId: null,
            search: '', // Valor del campo de búsqueda
            dialog_guardando: false,
            snackbar: false, snackbarMensaje: '', snackbarColor: 'error',
            minDate: '1900-01-01', maxDate: '2099-12-31',
            r: {
                req: v => (v !== null && v !== undefined && String(v).trim() !== '') || 'Campo obligatorio',
                email: v => {
                    if (!v) return 'Campo obligatorio';

                    //const re = /^[a-zA-Z0-9._%+-]+@(un\.org|policia\.bo)$/i;
                    const re = /^[a-zA-Z0-9._%+-]+@(policia\.bo)$/i;

                    return re.test(String(v).trim())
                        || 'Solo se permiten correos @policia.bo';
                },
                phone: v => {
                    if (!v) return 'Campo obligatorio';
                    return (/^\d{7,15}$/).test(String(v)) || 'Teléfono inválido';
                },
                combo: v => (v !== null && v !== undefined) || 'Seleccione una opción',
                date: v => {
                    if (!v) return 'Seleccione una fecha';
                    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(v);
                    if (!m) return 'Formato inválido (aaaa-mm-dd)';
                    const y = +m[1];
                    if (y < 1900 || y > 2099) return 'Año fuera de rango (1900–2099)';
                    return true;
                },
            },
            formValid: false,
            FilterArea: [], FilterRol: [],
            Catalogo: {
                EstadoCivil: [],
                TipoDocumento: [],
                Nacionalidad: [],
                Genero: [],
                TipoSangre: [],
                Parentesco: [],
            },
            map: null,
            marker: null,
            dialogDetalle: false,
            personaSeleccionada: {},
            totalItems: 0,
            loadingTable: false,
            tableOptions: {
                page: 1,
                itemsPerPage: 30
            },
            searchTimeout: null,
            filtros: {
                oid_tipo_documento: [],
                oid_genero: [],
                oid_estado_civil: [],
                oid_pais: [],
                oid_depto: [],
                oid_ciudad: [],
                oid_estado: [],
                oid_grado: [],
                oid_cargo: [],
                oid_unidad: [],
                oid_destino: [],
                verificado: [],
                oid_categoria: [],
                oid_frontera: [],
                oid_funciones: [],
                grado_policial: [],
            },
            verFiltros: false,
            dialogImportar: false,
            dialogKeyR: 0,
            validandoDocumento: false, validandoCorreo: false, validandoEscalafon: false,
            existeDocumento: false, existeCorreo: false, existeEscalafon: false,
            timeoutDocumento: null, timeoutCorreo: null, timeoutEscalafon: null,
            dialogKeyD: 0,
        };
    },
    watch: {
        tableOptions: {
            handler() {
                this.listar();
            },
            deep: true
        },
        search() {
            clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(() => {
                this.tableOptions.page = 1;
                this.listar();
            }, 500);
        },
        filtros: {
            handler() {
                this.tableOptions.page = 1;
                this.listar();
            },
            deep: true
        },
        dialog(val) {
            if (val) {
                this.$nextTick(() => {
                    this.initMap();
                });
            } else {
                if (this.map) {
                    this.map.remove();
                    this.map = null;
                    this.marker = null;
                }
            }
        },
        /*async 'dato.oid_ciudad'(val) {
            if (!val || !this.dialog) return;

            const ciudad = this.LCiudad.find(c => c.oid === val);
            if (!ciudad) return;

            await this.$nextTick();

            if (!this.map) {
                this.initMap();
                await this.$nextTick();
            }

            await this.geocodeCiudad(ciudad.nombre);
        },*/
        async 'dato.oid_ciudad'(val) {
            if (!val || !this.dialog) return;

            await this.$nextTick();

            if (!this.map) {
                this.initMap();
                await this.$nextTick();
            }

            // Si ya tiene ubicación guardada, no buscar por ciudad
            if (this.dato.lat && this.dato.lng) {
                this.setMarker(this.dato.lat, this.dato.lng, 16);
                return;
            }

            const ciudad = this.LCiudad.find(c => Number(c.oid) === Number(val));
            if (!ciudad) return;

            await this.geocodeCiudad(ciudad.nombre);
        }
    },
    computed: {
        headers() {
            const baseHeaders = [
                { text: 'Acciones', value: 'actions', sortable: false },
                { text: 'Documento', value: 'documento' },
                { text: 'Nombres', value: 'nombres' },
                { text: 'Primer Apellido', value: 'primero_apellido' },
                { text: 'Segundo Apellido', value: 'segundo_apellido' },
                { text: 'Tercer Apellido', value: 'tercer_apellido' },
                { text: 'Correo', value: 'correo' },
                // { text: 'Rol', value: 'rol' },
                // { text: 'Área', value: 'area' },
                { text: 'Estado', value: 'n_est' },
            ];

            return baseHeaders;
        },
        usernombres() {
            const user = localStorage.getItem('usernombres'); 
            return user;
        },
        rolOid() {
            const oid_rol = localStorage.getItem('rolu');
            return Number(oid_rol);
        },    
        userOid() {
            const oid_user = localStorage.getItem('oidu');
            return Number(oid_user);
        },
        deptoFiltrado() {
            if (!this.dato.oid_pais) return [];
            return this.LDepto.filter(d => d.oid_pais === this.dato.oid_pais);
        },
        ciudadFiltrado() {
            if (!this.dato.oid_depto) return [];
            return this.LCiudad.filter(d => d.oid_depto === this.dato.oid_depto);
        },
        deptoFiltradoN() {
            if (!this.dato.oid_pais_nacimiento) return [];
            return this.LDepto.filter(d => d.oid_pais === this.dato.oid_pais_nacimiento);
        },
        ciudadFiltradoN() {
            if (!this.dato.oid_depto_nacimiento) return [];
            return this.LCiudad.filter(d => d.oid_depto === this.dato.oid_depto_nacimiento);
        },
        catMap() {
            const toMap = arr => (arr || []).reduce((m, it) => { m[it.oid] = it.nombre; return m; }, {});
            return {
                TipoDocumento: toMap(this.Catalogo.TipoDocumento),
                Nacionalidad:  toMap(this.Catalogo.Nacionalidad),
                Genero:        toMap(this.Catalogo.Genero),
                EstadoCivil:   toMap(this.Catalogo.EstadoCivil),
                TipoSangre:    toMap(this.Catalogo.TipoSangre),
                Parentesco:    toMap(this.Catalogo.Parentesco),
            };
        }
    },
    async mounted() {
        await this.cargarCatalogos();

        await setDatos();
        this.LPais   = getPaises();
        this.LDepto  = getDeptos();
        this.LCiudad = getCiudades();

        this.listar();
    },
    methods: {
        async cargarCatalogos() {
            await loadAll();

            this.Catalogo.TipoDocumento   = getOptionsByCodigo('TipoDocumento');
            this.Catalogo.Nacionalidad = getOptionsByCodigo('Nacionalidad');
            this.Catalogo.Genero        = getOptionsByCodigo('Genero');
            this.Catalogo.EstadoCivil        = getOptionsByCodigo('EstadoCivil');
            this.Catalogo.TipoSangre    = getOptionsByCodigo('TipoSangre');
            this.Catalogo.Parentesco    = getOptionsByCodigo('Parentesco');
        },
        setMarker(lat, lng, zoom = 16) {
            if (!this.map) return;

            console.log("SET MARKER:", lat, lng);

            this.$set(this.dato, 'lat', Number(lat));
            this.$set(this.dato, 'lng', Number(lng));

            this.map.setView([lat, lng], zoom);

            if (this.marker) {
                this.marker.setLatLng([lat, lng]);
            } else {
                this.marker = L.marker([lat, lng], {
                    draggable: true
                }).addTo(this.map);

                this.marker.on('dragend', (e) => {
                    const pos = e.target.getLatLng();
                    this.$set(this.dato, 'lat', Number(pos.lat));
                    this.$set(this.dato, 'lng', Number(pos.lng));
                });
            }
        },
        initMap() {
            const container = document.getElementById('mapa');
            if (!container) return;

            if (this.map) {
                setTimeout(() => {
                    this.map.invalidateSize();
                }, 200);
                return;
            }

            this.map = L.map(container).setView([-16.3241, -64.0698], 5);

            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '&copy; OpenStreetMap'
            }).addTo(this.map);

            this.map.on('click', (e) => {
                const { lat, lng } = e.latlng;
                this.setMarker(lat, lng, 16);
            });

            setTimeout(() => {
                this.map.invalidateSize();
            }, 200);
        },
        async geocodeCiudad(ciudadNombre) {
            try {
                const depto = this.LDepto.find(d => d.oid === this.dato.oid_depto);
                const pais = this.LPais.find(p => p.oid === this.dato.oid_pais);

                const query = [
                    ciudadNombre,
                    depto ? depto.nombre : '',
                    pais ? pais.nombre : ''
                ].filter(Boolean).join(', ');

                const res = await axios.get('https://nominatim.openstreetmap.org/search', {
                    params: {
                        q: query,
                        format: 'json',
                        limit: 1
                    },
                    headers: {
                        'Accept-Language': 'es'
                    }
                });

                if (res.data && res.data.length > 0) {
            const lat = parseFloat(res.data[0].lat);
            const lng = parseFloat(res.data[0].lon);

            console.log("GEOCODE:", lat, lng); // 👈 DEBUG

            this.setMarker(lat, lng, 13);
        }
            } catch (error) {
                console.error('Error geocodificando ciudad:', error);
            }
        },
        // Obtener la lista
        async listar() {
            try {
                this.loadingTable = true;

                this.roles = await setRols();
                this.Larea = await setAreas();
                this.Lestado = await setEstados();

                const responseG = await axios.get('api/Grados/Listar');
                const responseC = await axios.get('api/Cargos/Listar');
                const responseU = await axios.get('api/Unidads/Listar');
                const responseD = await axios.get('api/Destinos/Listar');
                const responseCas = await axios.get('api/Categoria_cas/Listar');
                const responseFB = await axios.get('api/FonteraBonos/Listar');
                const responseF = await axios.get('api/Funciones/Listar');
                const responseGP = await axios.get('api/GradoPolicials/Listar');

                const { page, itemsPerPage } = this.tableOptions;

                const response = await axios.get('api/PersonaInfoGenerals/ListarCompleto', {
                    params: {
                        page,
                        pageSize: itemsPerPage,
                        search: this.search || '',

                        oid_tipo_documento: this.filtros.oid_tipo_documento,
                        oid_genero: this.filtros.oid_genero,
                        oid_estado_civil: this.filtros.oid_estado_civil,
                        oid_pais: this.filtros.oid_pais,
                        oid_depto: this.filtros.oid_depto,
                        oid_ciudad: this.filtros.oid_ciudad,
                        oid_estado: this.filtros.oid_estado,
                        oid_grado: this.filtros.oid_grado,
                        oid_cargo: this.filtros.oid_cargo,
                        oid_unidad: this.filtros.oid_unidad,
                        oid_destino: this.filtros.oid_destino,
                        verificado: this.filtros.verificado,
                        oid_categoria: this.filtros.oid_categoria,
                        oid_frontera: this.filtros.oid_frontera,
                        oid_funciones: this.filtros.oid_funciones,
                        grado_policial: this.filtros.grado_policial,
                    },
                    paramsSerializer: params => {
                        const searchParams = new URLSearchParams();

                        Object.keys(params).forEach(key => {
                            const value = params[key];

                            if (Array.isArray(value)) {
                                value.forEach(v => {
                                    if (v !== null && v !== undefined && v !== '') {
                                        searchParams.append(key, v);
                                    }
                                });
                            } else if (value !== null && value !== undefined && value !== '') {
                                searchParams.append(key, value);
                            }
                        });

                        return searchParams.toString();
                    }
                });

                this.datos = response.data.data.map(h => ({
                    ...h,
                    act: h.activo === 1 || h.activo === true ? 'Si' : 'No',
                    n_est: this.getEstadoN(h.oid_estado)
                }));

                this.totalItems = response.data.total;
                
                this.Lgrado = responseG.data;
                this.Lcargo = responseC.data;
                this.Lunidad = responseU.data;
                this.Ldestino = responseD.data;
                this.Lcas = responseCas.data;
                this.Lfrontera = responseFB.data;
                this.Lgpolicial = responseGP.data;
                this.Lfunciones = responseF.data;

            } catch (error) {
                console.error(error);
                this.snackbarMensaje = "Error al listar funcionarios";
                this.snackbarColor = "error";
                this.snackbar = true;
            } finally {
                this.loadingTable = false;
            }
        },
        // Mostrar detalles
        async mostrarPersona(id) {
            try {
                this.dialogdetail = false;

                const response = await axios.get(`api/PersonaInfoGenerals/Mostrar/${id}`);

                this.dato = response.data;
                this.isNew = false;
                this.formTitle = 'Detalle Usuario';

                this.dialogKeyD++;
                this.$nextTick(() => {
                    this.dialogdetail = true;
                });

            } catch (error) {
                console.error(error);
            }
        },
        // Abrir el diálogo para crear una nuevo
        nueva() {
            this.dato = {
                oid: 0,
                password_hash: 'aa',
                nombres: '',
                primero_apellido: '',
                segundo_apellido: '',
                tercer_apellido: '',
                oid_tipo_documento: null,
                documento: '',
                fecha_nacimiento: null,
                oid_pais_nacimiento: null,
                oid_depto_nacimiento: null,
                oid_ciudad_nacimiento: null,
                oid_nacionalidad_origen: null,
                oid_nacionalidad_actual: null,
                oid_estado_civil: null,
                direccion: '',
                calle: '',
                zona: '',
                nro_domicilio: '',
                oid_pais: null,
                oid_depto: null,
                oid_ciudad: null,
                n_contacto: '',
                nro_contacto: '',
                oid_parentesco_contacto: null,
                telefono: '',
                oid_user: this.userOid,
                verificado: 0,
                activo: true,
                lat: null,
                lng: null,
                oid_estado: null,
                cl1: '',
                cl2: '',
                fecha_ingreso: null,
                fecha_retiro: null,
                fecha_reintegro: null,
                fecha_reasignacion: null,
                oid_grado: null,
                oid_cargo: null,
                oid_unidad: null,
                oid_destino: null,
                cod_salud: '',
                registro_cua: '',
                nro_cuenta: '',
                expedido: '',
                grado_incapacidad: '',
                oid_categoria: null,
                bono_egresado: '',
                cod_cargo: '',
                oid_tipo_sangre: null,
                oid_frontera: null,
                oid_funciones: null,
                grado_policial: null,
            };
            this.isNew = true;
            this.formTitle = 'Registrar Funcionario';
            this.dialog = true;
            
            this.existeDocumento= false;
            this.existeCorreo= false;
            this.existeEscalafon= false;

            this.$nextTick(() => {
                this.$refs.form && this.$refs.form.resetValidation();
                this.formValid= false;

                // Volver al inicio del formulario
                if (this.$refs.dialogBody) {
                    this.$refs.dialogBody.scrollTop = 0;
                }
            });
        },
        // Abrir el diálogo para actualizar
        async editar(item) {
            const response = await axios.get(`api/PersonaInfoGenerals/Mostrar/${item.oid}`);

            this.dato = {
                ...response.data,
                fecha_nacimiento: response.data.fecha_nacimiento ? response.data.fecha_nacimiento.substring(0, 10) : null,
                fecha_ingreso: response.data.fecha_ingreso ? response.data.fecha_ingreso.substring(0, 10) : null,
                fecha_retiro: response.data.fecha_retiro ? response.data.fecha_retiro.substring(0, 10) : null,
                fecha_reintegro: response.data.fecha_reintegro ? response.data.fecha_reintegro.substring(0, 10) : null,
                fecha_reasignacion: response.data.fecha_reasignacion ? response.data.fecha_reasignacion.substring(0, 10) : null,
            };

            this.isNew = false;
            this.formTitle = 'Actualizar Funcionario';
            this.dialog = true;

            this.$nextTick(() => {
                this.$refs.form && this.$refs.form.resetValidation();

                if (this.$refs.dialogBody) {
                    this.$refs.dialogBody.scrollTop = 0;
                }

                setTimeout(() => {
                    if (this.dato.lat && this.dato.lng) {
                        this.setMarker(
                            this.dato.lat,
                            this.dato.lng,
                            16
                        );
                    }
                }, 300);
            });
        },
        // Guardar creada o actualizada
        async guardar() {
            // VALIDACION
            const ok = this.$refs.form && this.$refs.form.validate();
            if (!ok) return;

            if (this.existeDocumento || this.existeCorreo || this.existeEscalafon) {
                this.snackbarMensaje = "Corrige los campos duplicados antes de guardar.";
                this.snackbarColor = "error";
                this.snackbar = true;
                return;
            }

            this.dialog_guardando = true;
            try {        
                if (this.isNew) {
                    let oid_userCPersona;
                    let oid_userCUser;

                    const payloadPersona = {
                        correo: this.dato.correo,
                        nombres: this.dato.nombres,
                        primero_apellido: this.dato.primero_apellido,
                        segundo_apellido: this.dato.segundo_apellido,
                        tercer_apellido: this.dato.tercer_apellido,
                        oid_tipo_documento: this.dato.oid_tipo_documento,
                        documento: this.dato.documento,
                        oid_genero: this.dato.oid_genero,
                        fecha_nacimiento: this.dato.fecha_nacimiento,
                        oid_pais_nacimiento: this.dato.oid_pais_nacimiento,
                        oid_depto_nacimiento: this.dato.oid_depto_nacimiento,
                        oid_ciudad_nacimiento: this.dato.oid_ciudad_nacimiento,
                        oid_nacionalidad_origen: this.dato.oid_nacionalidad_origen,
                        oid_nacionalidad_actual: this.dato.oid_nacionalidad_actual,
                        oid_estado_civil: this.dato.oid_estado_civil,
                        direccion: this.dato.direccion,
                        calle: this.dato.calle,
                        zona: this.dato.zona,
                        nro_domicilio: this.dato.nro_domicilio,
                        lat: this.dato.lat,
                        lng: this.dato.lng,
                        oid_pais: this.dato.oid_pais,
                        oid_depto: this.dato.oid_depto,
                        oid_ciudad: this.dato.oid_ciudad,
                        n_contacto: this.dato.n_contacto,
                        nro_contacto: this.dato.nro_contacto,
                        oid_parentesco_contacto: this.dato.oid_parentesco_contacto,
                        telefono: this.dato.telefono,
                        oid_user: this.dato.oid_user,
                        activo: this.dato.activo,
                        oid_estado: this.dato.oid_estado,
                        cl1: this.dato.cl1,
                        cl2: this.dato.cl2,
                        fecha_ingreso: this.dato.fecha_ingreso,
                        fecha_retiro: this.dato.fecha_retiro,
                        fecha_reintegro: this.dato.fecha_reintegro,
                        fecha_reasignacion: this.dato.fecha_reasignacion,
                        oid_grado: this.dato.oid_grado,
                        oid_cargo: this.dato.oid_cargo,
                        oid_unidad: this.dato.oid_unidad,
                        oid_destino: this.dato.oid_destino,
                        cod_salud: this.dato.cod_salud,
                        registro_cua: this.dato.registro_cua,
                        nro_cuenta: this.dato.nro_cuenta,
                        expedido: this.dato.expedido,
                        grado_incapacidad: this.dato.grado_incapacidad,
                        oid_categoria: this.dato.oid_categoria,
                        bono_egresado: this.dato.bono_egresado,
                        cod_cargo: this.dato.cod_cargo,
                        oid_tipo_sangre: this.dato.oid_tipo_sangre,
                        oid_funciones: this.dato.oid_funciones,
                        oid_frontera: this.dato.oid_frontera,
                        grado_policial: this.dato.grado_policial,
                    };
                    console.log(payloadPersona);

                    // Crear el área
                    const respuestaCrear = await axios.post('api/PersonaInfoGenerals/Crear', payloadPersona);
                    oid_userCPersona = respuestaCrear.data.oid;

                    const payloadUser = {
                        document: this.dato.documento,
                        names: this.dato.nombres,
                        surname: `${this.dato.primero_apellido || ''} ${this.dato.segundo_apellido || ''} ${this.dato.tercer_apellido || ''}`.trim(),
                        email: this.dato.correo,
                        oid_rol: 2,
                        oid_area: 1,
                        activo: 1,
                        supervisor_id: oid_userCPersona
                    };

                    const respuestaCrearU = await axios.post('api/Users/Crear', payloadUser);
                    oid_userCUser = respuestaCrearU.data.oid;

                    const payloadUserUbi = {
                        oid_persona: oid_userCPersona,
                        oid_user: oid_userCUser,
                        direccion: this.dato.direccion,
                        lat: this.dato.lat,
                        lng: this.dato.lng,
                        oid_pais: this.dato.oid_pais,
                        oid_depto: this.dato.oid_depto,
                        oid_ciudad: this.dato.oid_ciudad,
                        activo: true
                    };

                    await axios.post('api/PersonaUbicacions/Crear', payloadUserUbi);
                } else {
                    const payloadActualizar = {
                        ...this.dato,
                        oid_user: this.userOid
                    };
                    // Actualizar el área
                    await axios.put(`api/PersonaInfoGenerals/Actualizar`, payloadActualizar);
                }

                // Reset del formulario
                if (this.$refs.form) {
                    this.$refs.form.reset();
                    this.$refs.form.resetValidation();
                }

                // Limpiar el formulario después de guardar o actualizar
                this.dato = { 
                    oid: 0, 
                    nombres: '',
                    primero_apellido: '',
                    segundo_apellido: '',
                    tercer_apellido: '',
                    oid_tipo_documento: null,
                    documento: '',
                    fecha_nacimiento: null,
                    oid_pais_nacimiento: null,
                    oid_depto_nacimiento: null,
                    oid_ciudad_nacimiento: null,
                    oid_nacionalidad_origen: null,
                    oid_nacionalidad_actual: null,
                    oid_estado_civil: null,
                    direccion: '',
                    calle: '',
                    zona: '',
                    nro_domicilio: '',
                    oid_pais: null,
                    oid_depto: null,
                    oid_ciudad: null,
                    n_contacto: '',
                    nro_contacto: '',
                    oid_parentesco_contacto: null,
                    telefono: '',
                    oid_user: null,
                    verificado: null,
                    activo: null,
                    lat: null,
                    lng: null,
                    oid_estado: null,
                    cl1: '',
                    cl2: '',
                    fecha_ingreso: null,
                    fecha_retiro: null,
                    fecha_reintegro: null,
                    fecha_reasignacion: null,
                    oid_grado: null,
                    oid_cargo: null,
                    oid_unidad: null,
                    oid_destino: null,
                    cod_salud: '',
                    registro_cua: '',
                    nro_cuenta: '',
                    expedido: '',
                    grado_incapacidad: '',
                    oid_categoria: null,
                    bono_egresado: '',
                    cod_cargo: '',
                    oid_tipo_sangre: null,
                    oid_frontera: null,
                    oid_funciones: null,
                    grado_policial: null,
                };
                // Después de guardar exitosamente el registro:
                this.dialog = false;
                await this.listar();
                
                this.snackbarMensaje = "Se guardo correctamente";
                this.snackbarColor = "success";
                this.snackbar = true;
            }catch(error) {
                console.error(error);
                this.snackbarMensaje = "Error al guardar";
                this.snackbarColor = "error";
                this.snackbar = true;
            } finally {
                // Independientemente de si la solicitud tuvo éxito o no, detenemos el estado de carga.
                this.dialog_guardando = false;
            }
        },
        // Eliminar 
        async eliminar(id) {
            try {
                await axios.delete(`api/PersonaInfoGenerals/Eliminar/${id}`);
                this.listar();
                this.cancelarEliminar();
            } catch (error) {
                console.error(error);
            }
        },
        // Confirmar eliminación
        confirmarEliminar(id) {
            this.confirmItemId = id;
            this.showConfirmDialog = true;
        },
        // Cancelar eliminación
        cancelarEliminar() {
            this.confirmItemId = null;
            this.showConfirmDialog = false;
        },
        getRolN, getAreaN,
        getEstadoN(id) {
            const item = (this.Lestado || []).find(x => Number(x.oid) === Number(id));
            return item ? (item.n_estado || 'Sin dato') : 'Sin dato';
        },
        getGradoN(id) {
            const item = (this.Lgrado || []).find(x => Number(x.oid) === Number(id));
            return item ? (item.nombre || 'Sin dato') : 'Sin dato';
        },
        getCargoN(id) {
            const item = (this.Lcargo || []).find(x => Number(x.oid) === Number(id));
            return item ? (item.nombre || 'Sin dato') : 'Sin dato';
        },
        getUnidadN(id) {
            const item = (this.Lunidad || []).find(x => Number(x.oid) === Number(id));
            return item ? (item.nombre || 'Sin dato') : 'Sin dato';
        },
        getDestinoN(id) {
            const item = (this.Ldestino || []).find(x => Number(x.oid) === Number(id));
            return item ? (item.nombre || 'Sin dato') : 'Sin dato';
        },
        getGradoPN(id) {
            const item = (this.Lgpolicial || []).find(x => Number(x.oid) === Number(id));
            return item ? (item.nombre || 'Sin dato') : 'Sin dato';
        },
        getFronteraN(id) {
            const item = (this.Lfrontera || []).find(x => Number(x.oid) === Number(id));
            return item ? (item.nombre || 'Sin dato') : 'Sin dato';
        },
        getCategoriaN(id) {
            const item = (this.Lcas || []).find(x => Number(x.oid) === Number(id));
            return item ? (item.nombre || 'Sin dato') : 'Sin dato';
        },
        getFuncionesN(id) {
            const item = (this.Lfunciones || []).find(x => Number(x.oid) === Number(id));
            return item ? (item.nombre || 'Sin dato') : 'Sin dato';
        },
        limpiarFiltros() {
            this.filtros = {
                oid_tipo_documento: [],
                oid_genero: [],
                oid_estado_civil: [],
                oid_pais: [],
                oid_depto: [],
                oid_ciudad: [],
                oid_estado: [],
                oid_grado: [],
                oid_cargo: [],
                oid_unidad: [],
                oid_destino: [],
                verificado: []
            };

            this.search = '';
            this.tableOptions.page = 1;
            this.listar();
        },
        // EXPORTAR EXCEL
        crearParamsListado(page = 1, pageSize = 30) {
            return {
                page,
                pageSize,
                search: this.search || '',

                oid_tipo_documento: this.filtros.oid_tipo_documento,
                oid_genero: this.filtros.oid_genero,
                oid_estado_civil: this.filtros.oid_estado_civil,
                oid_pais: this.filtros.oid_pais,
                oid_depto: this.filtros.oid_depto,
                oid_ciudad: this.filtros.oid_ciudad,
                oid_estado: this.filtros.oid_estado,
                oid_grado: this.filtros.oid_grado,
                oid_cargo: this.filtros.oid_cargo,
                oid_unidad: this.filtros.oid_unidad,
                oid_destino: this.filtros.oid_destino,
                verificado: this.filtros.verificado
            };
        },
        serializarParams(params) {
            const searchParams = new URLSearchParams();

            Object.keys(params).forEach(key => {
                const value = params[key];

                if (Array.isArray(value)) {
                    value.forEach(v => {
                        if (v !== null && v !== undefined && v !== '') {
                            searchParams.append(key, v);
                        }
                    });
                } else if (value !== null && value !== undefined && value !== '') {
                    searchParams.append(key, value);
                }
            });

            return searchParams.toString();
        },
        async exportarExcel() {
            try {
                this.loadingTable = true;

                const pageSize = 5000;
                let page = 1;
                let total = 0;
                let todos = [];

                do {
                    const response = await axios.get('api/PersonaInfoGenerals/ListarCompleto', {
                        params: this.crearParamsListado(page, pageSize),
                        paramsSerializer: this.serializarParams
                    });

                    const data = response.data.data || [];
                    total = response.data.total || 0;

                    todos = todos.concat(data);
                    page++;
                } while (todos.length < total);

                this.generarExcelFuncionarios(todos, 'Funcionarios');

            } catch (error) {
                console.error(error);
                this.snackbarMensaje = "Error al exportar funcionarios";
                this.snackbarColor = "error";
                this.snackbar = true;
            } finally {
                this.loadingTable = false;
            }
        },
        generarExcelFuncionarios(datos, nombre) {
            const rows = datos.map(item => {
                return {
                    "Documento": item.documento || "",
                    "Tipo documento": this.catMap?.TipoDocumento?.[item.oid_tipo_documento] || "Sin dato",
                    "Nombres": item.nombres || "",
                    "Primer apellido": item.primero_apellido || "",
                    "Segundo apellido": item.segundo_apellido || "",
                    "Tercer apellido": item.tercer_apellido || "",
                    "Correo": item.correo || "",
                    "Teléfono": item.telefono || "",
                    "Género": this.catMap?.Genero?.[item.oid_genero] || "Sin dato",
                    "Estado civil": this.catMap?.EstadoCivil?.[item.oid_estado_civil] || "Sin dato",
                    "Fecha nacimiento": item.fecha_nacimiento ? item.fecha_nacimiento.substring(0, 10) : "",
                    "Edad (años)": this.calcularEdad(item.fecha_nacimiento),
                    "País nacimiento": getPaisN(item.oid_pais_nacimiento) || "Sin dato",
                    "Departamento nacimiento": getDeptoN(item.oid_depto_nacimiento) || "Sin dato",
                    "Ciudad nacimiento": getCiudadN(item.oid_ciudad_nacimiento) || "Sin dato",
                    "Nacionalidad origen": this.catMap?.Nacionalidad?.[item.oid_nacionalidad_origen] || "Sin dato",
                    "Nacionalidad actual": this.catMap?.Nacionalidad?.[item.oid_nacionalidad_actual] || "Sin dato",
                    "País residencia": getPaisN(item.oid_pais) || "Sin dato",
                    "Departamento residencia": getDeptoN(item.oid_depto) || "Sin dato",
                    "Ciudad residencia": getCiudadN(item.oid_ciudad) || "Sin dato",
                    "Dirección": item.direccion || "",
                    "Calle": item.calle || "",
                    "Zona": item.zona || "",
                    "Nro. domicilio": item.nro_domicilio || "",
                    "Latitud": item.lat || "",
                    "Longitud": item.lng || "",
                    "Fecha ingreso": item.fecha_ingreso ? item.fecha_ingreso.substring(0, 10) : "",
                    "Fecha retiro": item.fecha_retiro ? item.fecha_retiro.substring(0, 10) : "",
                    "Fecha reintegro": item.fecha_reintegro ? item.fecha_reintegro.substring(0, 10) : "",
                    "Fecha reasignacion": item.fecha_reasignacion ? item.fecha_reasignacion.substring(0, 10) : "",
                    "Código salud": item.cod_salud || "",
                    "Registro CUA": item.registro_cua || "",
                    "Nro. cuenta": item.nro_cuenta || "",
                    "Grado incapacidad": item.grado_incapacidad || "",
                    "Tipo sangre": this.catMap?.TipoSangre?.[item.oid_tipo_sangre] || "Sin dato",
                    "Nro. Escalafon": item.cl1 || "",
                    "Estado": this.getEstadoN(item.oid_estado),
                    "Grado": this.getGradoN(item.oid_grado),
                    "Grado policial": this.getGradoPN ? this.getGradoPN(item.grado_policial) : item.grado_policial || "",
                    "Cargo": this.getCargoN(item.oid_cargo),
                    "Función Policial": this.getFuncionesN ? this.getFuncionesN(item.oid_funciones) : item.oid_funciones || "",
                    "Código cargo": item.cod_cargo || "",
                    "Unidad": this.getUnidadN(item.oid_unidad),
                    "Destino": this.getDestinoN(item.oid_destino),
                    "Frontera": this.getFronteraN ? this.getFronteraN(item.oid_frontera) : item.oid_frontera || "",
                    "Categoría": this.getCategoriaN ? this.getCategoriaN(item.oid_categoria) : item.oid_categoria || "",
                    "Bono egresado": item.bono_egresado || "",
                    "Expedido": item.expedido || "",
                    "Parentesco contacto": this.catMap?.Parentesco?.[item.oid_parentesco_contacto] || "Sin dato",
                    "Nombre contacto": item.n_contacto || "",
                    "Nro. contacto": item.nro_contacto || "",
                    "Documento Supervisor": item.cl2 || "",
                    "Usuario registro": item.oid_user || "",
                    "Fecha registro": item.created_at ? item.created_at.substring(0, 10) : "",
                };
            });

            const hoja = utils.json_to_sheet(rows);

            hoja["!cols"] = [
                { wch: 16 },
                { wch: 24 },
                { wch: 22 },
                { wch: 22 },
                { wch: 30 },
                { wch: 16 },
                { wch: 10 },
                { wch: 16 },
                { wch: 18 },
                { wch: 18 },
                { wch: 24 },
                { wch: 24 },
                { wch: 18 },
                { wch: 22 },
                { wch: 26 },
                { wch: 26 },
                { wch: 28 },
                { wch: 30 }
            ];

            const libro = utils.book_new();
            utils.book_append_sheet(libro, hoja, "Funcionarios");

            const fecha = new Date().toISOString().substring(0, 10);
            writeFileXLSX(libro, `${nombre}_${fecha}.xlsx`);
        },
        async descargarPlantillaFuncionarios() {
            const workbook = new ExcelJS.Workbook();

            const hoja = workbook.addWorksheet("Funcionarios");
            const listas = workbook.addWorksheet("Listas");

            listas.state = "veryHidden";

            const columnas = [
                "Documento",
                "Tipo documento",
                "Nombres",
                "Primer apellido",
                "Segundo apellido",
                "Tercer apellido",
                "Correo",
                "Teléfono",
                "Género",
                "Estado civil",
                "Fecha nacimiento",
                "País nacimiento",
                "Departamento nacimiento",
                "Ciudad nacimiento",
                "Nacionalidad origen",
                "Nacionalidad actual",
                "País residencia",
                "Departamento residencia",
                "Ciudad residencia",
                "Dirección",
                "Calle",
                "Zona",
                "Nro. domicilio",
                "Estado",
                "Grado",
                "Cargo",
                "Unidad",
                "Destino",
                "Fecha ingreso",
                "Fecha retiro",
                "Fecha reintegro",
                "Fecha reasignación",
                "Código salud",
                "Registro CUA",
                "Nro. escalafón",          // cl1
                "Documento supervisor",
                "Nro. cuenta",
                "Grado incapacidad",
                "Tipo sangre",
                "Categoría CAS",
                "Bono egresado",
                "Código cargo",
                "Frontera",
                "Funciones",
                "Grado policial",
                "Expedido",
                "Parentesco contacto",
                "Nombre contacto",
                "Nro. contacto"
            ];

            hoja.addRow(columnas);

            hoja.getRow(1).font = { bold: true };
            hoja.getRow(1).height = 25;

            hoja.columns = columnas.map(col => ({
                header: col,
                key: col,
                width: 24
            }));

            const agregarLista = (nombreLista, valores, colIndexLista) => {
                listas.getCell(1, colIndexLista).value = nombreLista;

                valores.forEach((valor, index) => {
                    listas.getCell(index + 2, colIndexLista).value = valor;
                });

                return `Listas!$${this.colExcel(colIndexLista)}$2:$${this.colExcel(colIndexLista)}$${valores.length + 1}`;
            };

            const listasExcel = {
                tipoDocumento: agregarLista("Tipo documento", Object.values(this.catMap.TipoDocumento || {}), 1),
                genero: agregarLista("Género", Object.values(this.catMap.Genero || {}), 2),
                estadoCivil: agregarLista("Estado civil", Object.values(this.catMap.EstadoCivil || {}), 3),
                tipoSangre: agregarLista("Tipo sangre", Object.values(this.catMap.TipoSangre || {}), 4),
                parentesco: agregarLista("Parentesco", Object.values(this.catMap.Parentesco || {}), 5),

                estado: agregarLista("Estado", (this.Lestado || []).map(x => x.n_estado), 6),
                grado: agregarLista("Grado", (this.Lgrado || []).map(x => x.nombre), 7),
                cargo: agregarLista("Cargo", (this.Lcargo || []).map(x => x.nombre), 8),
                unidad: agregarLista("Unidad", (this.Lunidad || []).map(x => x.nombre), 9),
                destino: agregarLista("Destino", (this.Ldestino || []).map(x => x.nombre), 10),
                categoria: agregarLista("Categoría", (this.Lcas || []).map(x => x.nombre), 11),
                frontera: agregarLista("Frontera", (this.Lfrontera || []).map(x => x.nombre), 12),
                funciones: agregarLista("Funciones", (this.Lfunciones || []).map(x => x.nombre), 13),
                gradoPolicial: agregarLista("Grado policial", (this.Lgpolicial || []).map(x => x.nombre), 14),

                paises: agregarLista("Países", (this.LPais || []).map(x => x.nombre), 15),
                deptos: agregarLista("Departamentos", (this.LDepto || []).map(x => x.nombre), 16),
                ciudades: agregarLista("Ciudades", (this.LCiudad || []).map(x => x.nombre), 17),
                nacionalidades: agregarLista("Nacionalidades", Object.values(this.catMap.Nacionalidad || {}), 18),
            };

            const aplicarLista = (colLetra, formula) => {
                for (let row = 2; row <= 3001; row++) {
                    hoja.getCell(`${colLetra}${row}`).dataValidation = {
                        type: "list",
                        allowBlank: true,
                        formulae: [`=${formula}`],
                        showErrorMessage: true,
                        errorStyle: "error",
                        errorTitle: "Valor inválido",
                        error: "Seleccione un valor de la lista desplegable."
                    };
                }
            };

            aplicarLista("B", listasExcel.tipoDocumento);
            aplicarLista("I", listasExcel.genero);
            aplicarLista("J", listasExcel.estadoCivil);
            aplicarLista("L", listasExcel.paises);
            aplicarLista("M", listasExcel.deptos);
            aplicarLista("N", listasExcel.ciudades);
            aplicarLista("O", listasExcel.nacionalidades);
            aplicarLista("P", listasExcel.nacionalidades);
            aplicarLista("Q", listasExcel.paises);
            aplicarLista("R", listasExcel.deptos);
            aplicarLista("S", listasExcel.ciudades);
            aplicarLista("X", listasExcel.estado);
            aplicarLista("Y", listasExcel.grado);
            aplicarLista("Z", listasExcel.cargo);
            aplicarLista("AA", listasExcel.unidad);
            aplicarLista("AB", listasExcel.destino);
            aplicarLista("AM", listasExcel.tipoSangre);
            aplicarLista("AN", listasExcel.categoria);
            aplicarLista("AQ", listasExcel.frontera);
            aplicarLista("AR", listasExcel.funciones);
            aplicarLista("AS", listasExcel.gradoPolicial);
            aplicarLista("AU", listasExcel.parentesco);

            hoja.views = [{ state: "frozen", ySplit: 1 }];

            const buffer = await workbook.xlsx.writeBuffer();
            saveAs(
                new Blob([buffer]),
                `Plantilla_Cargue_Funcionarios_${new Date().toISOString().substring(0, 10)}.xlsx`
            );
        },
        colExcel(numero) {
            let columna = "";
            while (numero > 0) {
                const modulo = (numero - 1) % 26;
                columna = String.fromCharCode(65 + modulo) + columna;
                numero = Math.floor((numero - modulo) / 26);
            }
            return columna;
        },
        mostrarError(mensaje) {
            this.snackbarMensaje = mensaje;
            this.snackbarColor = 'error';
            this.snackbar = true;
        },
        mostrarSuccess(mensaje) {
            this.snackbarMensaje = mensaje;
            this.snackbarColor = 'success';
            this.snackbar = true;
        },
        calcularEdad(fechaNacimiento) {
            if (!fechaNacimiento) return "";

            const nacimiento = new Date(fechaNacimiento);
            const hoy = new Date();

            let edad = hoy.getFullYear() - nacimiento.getFullYear();

            const mes = hoy.getMonth() - nacimiento.getMonth();

            if (
                mes < 0 ||
                (mes === 0 && hoy.getDate() < nacimiento.getDate())
            ) {
                edad--;
            }

            return edad;
        },
        validarDocumentoNoExiste() {
            return !this.existeDocumento || 'El documento ya existe';
        },
        validarCorreoNoExiste() {
            return !this.existeCorreo || 'El correo ya existe';
        },
        validarEscalafonNoExiste() {
            return !this.existeEscalafon || 'El Nro. Escalafón ya existe';
        },
        validarCampoDuplicadoDebounce(campo) {
            const timeoutMap = {
                documento: 'timeoutDocumento',
                correo: 'timeoutCorreo',
                cl1: 'timeoutEscalafon'
            };

            clearTimeout(this[timeoutMap[campo]]);

            this[timeoutMap[campo]] = setTimeout(() => {
                this.validarCampoDuplicado(campo);
            }, 500);
        },
        async validarCampoDuplicado(campo) {
            const valor = (this.dato[campo] || '').toString().trim();

            if (!valor) {
                this.limpiarEstadoDuplicado(campo);
                return;
            }

            const loadingMap = {
                documento: 'validandoDocumento',
                correo: 'validandoCorreo',
                cl1: 'validandoEscalafon'
            };

            const existeMap = {
                documento: 'existeDocumento',
                correo: 'existeCorreo',
                cl1: 'existeEscalafon'
            };

            this[loadingMap[campo]] = true;

            try {
                const response = await axios.get('api/PersonaInfoGenerals/ValidarCampoDuplicado', {
                    params: {
                        campo,
                        valor,
                        oid: this.isNew ? 0 : this.dato.oid
                    }
                });

                this[existeMap[campo]] = response.data.existe === true;

            } catch (error) {
                console.error(error);
            } finally {
                this[loadingMap[campo]] = false;
            }
        },
        limpiarEstadoDuplicado(campo) {
            const existeMap = {
                documento: 'existeDocumento',
                correo: 'existeCorreo',
                cl1: 'existeEscalafon'
            };

            this[existeMap[campo]] = false;
        },
    },
};
</script> 
<style>
    p {
        font-family: 'Heebo', sans-serif !important;
    }
    h1 {
        font-family: 'Heebo', sans-serif !important;
    }

    .filtros-card {
        border-radius: 12px !important;
        background: rgba(255, 255, 255, 0.65) !important;
    }
    .perfil-dialog-card {
        background: #fbfcfa !important;
        border: 1px solid rgba(108, 117, 51, 0.16) !important;
        border-radius: 20px !important;
        overflow: hidden !important;
        box-shadow: 0 16px 42px rgba(56, 61, 24, 0.22) !important;
    }

    .perfil-dialog-title {
        background: linear-gradient(135deg, #e6e9de 0%, #dfe4d2 100%) !important;
        border-bottom: 1px solid rgba(108, 117, 51, 0.15) !important;
        color: #384018 !important;
        font-size: 22px !important;
        font-weight: 800 !important;
        padding: 18px 24px !important;
        justify-content: center;
        text-align: center;
    }

    .perfil-dialog-body {
        background: linear-gradient(180deg, #f8f9f6 0%, #eef0ea 100%) !important;
        padding: 24px !important;
    }

    .form-section-title {
        width: 100%;
        text-align: center;
        color: #384018 !important;
        font-size: 18px !important;
        font-weight: 800 !important;
        text-transform: uppercase;
        letter-spacing: 0.04em;
        margin: 14px 0 16px 0;
        padding-bottom: 12px;
        border-bottom: 1px solid rgba(108, 117, 51, 0.18);
        background: rgba(255, 255, 255, 0.6);
        border-radius: 12px;
        padding: 10px 16px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }

    .form-section-title::before {
        content: "●";
        color: #f7c325;
        font-size: 14px;
        margin-right: 10px;
    }

    /* Campos del formulario */
    .perfil-field .v-input__slot {
        background: linear-gradient(180deg, #f9faf8 0%, #eef0eb 100%) !important;
        border-radius: 14px !important;
        box-shadow: inset 0 1px 2px rgba(0,0,0,0.04);
    }

    .perfil-field .v-input__slot fieldset {
        border-color: rgba(108, 117, 51, 0.14) !important;
        border-left: 4px solid #c9a538 !important;
    }

    .perfil-field:hover .v-input__slot fieldset {
        border-color: rgba(201, 165, 56, 0.65) !important;
    }

    .perfil-field.v-input--is-focused .v-input__slot fieldset {
        border-color: #c9a538 !important;
        border-width: 1px !important;
        border-left-width: 4px !important;
    }

    .perfil-field .v-label {
        color: #727b4a !important;
        font-size: 15px !important;
        font-weight: 800 !important;
    }

    .perfil-field input {
        color: #303641 !important;
        font-weight: 700 !important;
    }

    .perfil-field .v-select__selection {
        color: #303641 !important;
        font-weight: 700 !important;
    }

    .perfil-field .v-icon {
        color: #e4b510 !important;
    }

    .perfil-field.v-input--is-focused .v-label {
        color: #5e672c !important;
    }

    /* Acciones inferiores */
    .perfil-dialog-actions {
        background: #fbfcfa !important;
        border-top: 1px solid rgba(108, 117, 51, 0.12);
        padding: 16px 24px 22px 24px;
    }

    .perfil-dialog-actions .v-btn--text {
        color: #5e672c !important;
        font-weight: 800 !important;
    }

    /* Botón guardar */
    .perfil-btn-primary {
        color: white !important;
        background-color: #5e672c !important;
        border-radius: 12px !important;
        font-size: 14px !important;
        font-weight: 800 !important;
        letter-spacing: 0.3px;
        text-transform: none !important;
        padding: 0 20px !important;
        box-shadow: 0 8px 18px rgba(56, 61, 24, 0.22) !important;
    }

    .perfil-btn-outline {
        color: #5e672c !important;
        border: 2px solid #5e672c !important;
        border-radius: 12px !important;
        font-size: 14px !important;
        font-weight: 800 !important;
        text-transform: none !important;
        padding: 0 20px !important;
    }

    .perfil-btn-primary:hover {
        filter: brightness(1.08);
    }
    .dialog-help-text {
        color: #6b7280 !important;
    }
    .required-star {
        color: #e53935;
        font-weight: 700;
    }
</style>
